import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { getPersistConfig } from 'redux-deep-persist';
import { persistReducer, persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import product from './product/reducer';
import auth from './auth/reducer';
import user from './user/reducer';
import form from './form/reducer';
import modal from './modal/reducer';
import banner from './banner/reducer';
import print from './print/reducer';
import ticket from './ticket/reducer';
import invoice from './invoice/reducer';
import validity from './validity/reducer';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './graphql/actionCreators';

const reducer = combineReducers({
  auth,
  user,
  form,
  modal,
  banner,
  product,
  print,
  ticket,
  invoice,
  validity,
});

const createNoopStorage = () => {
  return {
    getItem() {
      return Promise.resolve(null);
    },
    setItem(_key: any, value: any) {
      return Promise.resolve(value);
    },
    removeItem() {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window === 'undefined'
    ? createNoopStorage()
    : require('redux-persist/lib/storage').default;

const persistConfig = getPersistConfig({
  key: 'root',
  storage,
  blacklist: [
    'auth.authenticated',
    'print.connected',
    'modal',
    'banner.status',
    'invoice.loadings',
  ],
  rootReducer: reducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default function Store({ children }: any) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
      </PersistGate>
    </Provider>
  );
}
